/**
 * Persist that the user asked for more AI credits, so a later refresh/login
 * can show a one-time "topped up" notice once balance is > 0 again.
 *
 * Storage key is per user id.
 */

const STORAGE_PREFIX = "starmesh_ai_credits_awaiting_topup:";

/**
 * Mark that this user requested more credits (call after request-more succeeds).
 *
 * @example
 * markAiCreditsTopupRequested("c9eb0e33-...")
 */
export const markAiCreditsTopupRequested = (userId) => {
  const id = String(userId || "").trim();
  if (!id || typeof localStorage === "undefined") return;
  localStorage.setItem(`${STORAGE_PREFIX}${id}`, "1");
};

/**
 * True when the user previously requested a top-up and now has credits again.
 * Clears the awaiting flag when returning true (one-shot).
 *
 * @example
 * // after refresh with credits restored
 * consumeAiCreditsTopupNoticeIfReady({ id: "...", ai_credits_remaining: 100 })
 * // true (first call only)
 */
export const consumeAiCreditsTopupNoticeIfReady = (user) => {
  if (typeof localStorage === "undefined") return false;
  const id = String(user?.id || "").trim();
  if (!id) return false;
  const key = `${STORAGE_PREFIX}${id}`;
  if (localStorage.getItem(key) !== "1") return false;
  const remaining = Number(user?.ai_credits_remaining);
  if (!Number.isFinite(remaining) || remaining <= 0) return false;
  localStorage.removeItem(key);
  return true;
};
